export interface CashierWindowEvent {
    type: CashierEventType;
}

export enum CashierEventType {
    FundsAdded = 'FundsAdded',
    WindowResize = 'WindowResize',
    WindowScroll = 'WindowScroll',
    DepositAvailable = 'DepositAvailable',
    CashierPage = 'CashierPage',
    ClosePage = 'Close',
    SelectedPaymentMethod = 'SelectedPaymentMethod',
    MessageToNative = 'MESSAGE_TO_NATIVE',
}

export interface DepositAvailable extends CashierWindowEvent {
    available: boolean;
}

export interface SelectedPaymentMethod extends CashierWindowEvent {
    paymentMethodName?: PaymentMethod;
}

export enum PaymentMethod {
    GooglePay = 'GOOGLEPAY',
    ApplePay = 'APPLEPAY',
    ApplePayDirect = 'APPLEPAYDIRECT',
}

export interface FundsAdded extends CashierWindowEvent {
    success: boolean;
    amount: number;
    quickJourney: boolean;
}

export interface WindowResize extends CashierWindowEvent {
    height: number;
}

export interface WindowScroll extends CashierWindowEvent {
    clientX: number;
    clientY: number;
    deltaX: number;
    deltaY: number;
    layerX: number;
    layerY: number;
    offsetX: number;
    offsetY: number;
    pageX: number;
    pageY: number;
    wheelDeltaX: number;
    wheelDeltaY: number;
    x: number;
    y: number;
}

export interface CashierPage extends CashierWindowEvent {
    name: QuickDepositPage;
}

export const QUICK_DEPOSIT_IFRAME_CONSTANTS = {
    URL_PARAMS: {
        BRAND_ID: 'BWIN',
        PRODUCT_ID: 'SPORTSBOOK',
        CHANNEL_ID: {
            mobile: 'MW',
            tablet: 'TB',
            landscapeTablet: 'TB',
            desktop: 'WC',
        },
        LANG_ID: 'en',
    },
};

export enum QuickDepositSource {
    Betslip = 'Betslip',
    QuickBet = 'QuickBet',
    EditMyBet = 'Edit My Bet',
}

export enum QuickDepositPage {
    Deposit = 'Deposit',
    Withdrawal = 'Withdrawal',
}
